import { render, staticRenderFns } from "./ShipmentDetailTimeline.vue?vue&type=template&id=21158fa6&"
import script from "./ShipmentDetailTimeline.vue?vue&type=script&lang=js&"
export * from "./ShipmentDetailTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports